import React from 'react';
import { NavLink } from 'react-router-dom';
import { Users, UserPlus, Shield, Badge } from 'lucide-react';
import ADMIN_PATHS from '../ADMIN_PATHS';

const menuItems = [
  { path: ADMIN_PATHS.USERS, label: 'User List', icon: Users },
  { path: ADMIN_PATHS.USERS + '/create', label: 'Create User', icon: UserPlus },
  { path: ADMIN_PATHS.USERS + '/roles', label: 'Roles & Permissions', icon: Shield },
  { path: ADMIN_PATHS.USERS + '/details', label: 'User Details', icon: Badge },
];

const UserMenu = () => (
  <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/85 backdrop-blur">
    <div className="mx-auto px-4 md:px-6 py-3">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 min-w-0">
          <span className="h-4 w-[3px] rounded-full bg-primary" aria-hidden="true" />
          <h1 className="text-base md:text-lg font-black tracking-tight text-slate-900 truncate">
            User Management
          </h1>
        </div>
      </div>

      <nav className="mt-3 -mx-1 px-1 overflow-x-auto">
        <div className="flex items-center gap-2 whitespace-nowrap">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  [
                    'inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold transition-colors',
                    'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30',
                    isActive
                      ? 'border-primary/20 bg-primary/10 text-primary'
                      : 'border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50',
                  ].join(' ')
                }
              >
                <Icon size={16} className="shrink-0" />
                <span className="truncate">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  </header>
);

export default UserMenu; 